
import SmartNavbar from "../../../Components/SmartNavbar/SmartNavbar";
import Footer from "../../../Components/Footer/Footer";

const UserPrivacyPortalPage = () => {

  return (
    <div>
      <SmartNavbar />
      <div className={`mx-auto px-4 py-12 max-w-4xl`}>
        <h1 className={`font-semibold mb-4 text-2xl text-primary-600`}>{"Portal de Privacidade"}</h1>
        <p className="text-sm text-gray-700">
          {"Esta página será utilizada para solicitações relacionadas à privacidade de dados (acesso, correção e exclusão)."}
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default UserPrivacyPortalPage;
